const features = [
  {
    icon: "ri-stack-line",
    title: "多源播放",
    desc: "一集番剧聚合多个播放源，任一路由阻塞都能找到可用备选，从根源缓解线路卡顿。",
  },
  {
    icon: "ri-swap-line",
    title: "线路切换",
    desc: "无需退出页面，播放器内一键切换线路，支持手动挑选更清晰、更稳定的来源。",
  },
  {
    icon: "ri-radar-line",
    title: "自动选源",
    desc: "播放前自动探测各线路可用性与流畅度，优先加载最稳定的源，省心省力。",
  },
  {
    icon: "ri-flashlight-line",
    title: "备用线路秒切",
    desc: "播放中途卡顿可立即切至备用线路，秒级恢复，正片不断线、不重载。",
  },
];

export default function Features() {
  return (
    <section id="features" className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <div className="mx-auto max-w-2xl text-center">
          <span className="inline-block rounded-full bg-secondary-100 px-4 py-1 text-sm font-medium text-secondary-900">
            核心能力
          </span>
          <h2 className="mt-4 font-heading text-2xl text-foreground-950 md:text-4xl">
            一条线路卡住？这里还有整片森林
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-foreground-700 md:text-base">
            围绕看番体验打磨的四大能力，让线路切换、多源播放和自动选源成为日常标配，追番不再被卡顿打断。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4 md:gap-5">
          {features.map((f) => (
            <article
              key={f.title}
              className="rounded-lg border border-background-200 bg-background-100 p-5"
            >
              <span className="flex h-11 w-11 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className={`${f.icon} text-xl`}></i>
              </span>
              <h3 className="mt-4 text-base font-semibold text-foreground-950 md:text-lg">
                {f.title}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-700">{f.desc}</p>
            </article>
          ))}
        </div>

        <div className="mt-8 rounded-lg bg-background-200/70 p-5 md:p-6">
          <div className="flex flex-col items-center gap-4 text-center md:flex-row md:justify-center md:text-left">
            <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-accent-500 text-background-50">
              <i className="ri-question-line text-lg"></i>
            </span>
            <p className="text-sm text-foreground-800">
              播放过程中如果感觉卡顿，先点播放器里的"线路切换"，选择备用线路即可秒级恢复，无需刷新页面。
            </p>
            <a
              href="#how"
              className="whitespace-nowrap rounded-md border border-accent-500 px-4 py-2 text-sm font-medium text-accent-700 transition-colors hover:bg-accent-500 hover:text-background-50"
            >
              查看切换教程
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}